import { Component, inject, OnInit } from "@angular/core";
import { RaygunService } from "src/app/services/raygun/raygun.service";
import { NavigationEnd, Router } from "@angular/router";
import rg4js from "raygun4js";

@Component({
    selector: "app-raygun",
    template: "",
    providers: [RaygunService],
})
export class RaygunComponent implements OnInit {
    constructor(
        private raygunService: RaygunService,
        private router: Router,
    ) {}

    ngOnInit() {
        this.router.events.subscribe((event) => {
            // Track page views when the NavigationEnd event occurs
            if (event instanceof NavigationEnd) {
                rg4js("trackEvent", {
                    type: "pageView",
                    path: event.url,
                });
            }
        });
    }
}
